import {
  NORMAL,
  REGROUPEMENT,
  PERSONNALISE,
} from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import { BLOQUE } from '@/configuration/optionBlocage/optionBlocage';

function regroupementPersoWithAllLigneCommandable(referencePersonnalise, lignes) {
  const lignesWithRegroupementPerso = lignes.filter((ligne) => {
    return ligne.referencePersonnalise === referencePersonnalise
      && ligne.type !== PERSONNALISE;
  });
  return lignesWithRegroupementPerso.every((ligne) => {
    return ligne.type === NORMAL || (
      ligne.type === REGROUPEMENT && (ligne.typeProduit !== CATEGORIE_REGROUPEMENT
      || (ligne.typeProduit === CATEGORIE_REGROUPEMENT && ligne.etatObtenu === BLOQUE)));
  });
}

export default function getLignesCommandeForCommandePartielle(lignes) {
  return lignes.filter((ligne) => {
    return (!ligne.commandeId && ((ligne.type === NORMAL && !ligne.referencePersonnalise)
      || (ligne.type === REGROUPEMENT && !ligne.referencePersonnalise
        && (ligne.typeProduit !== CATEGORIE_REGROUPEMENT
          || (ligne.typeProduit === CATEGORIE_REGROUPEMENT && ligne.etatObtenu === BLOQUE)))
      || (ligne.type === PERSONNALISE
        && regroupementPersoWithAllLigneCommandable(ligne.referencePersonnalise, lignes))));
  });
}
